// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetNewbuildingJsonQueryRequest,
  TGetNewbuildingJsonQueryModel,
  IMappers,
  TGetNewbuildingJsonQueryResponse,
  IGetNewbuildingJsonQueryResponse,
  IGetNewbuildingJsonQueryResponseError,
} from './types';

export const defaultConfig: TGetNewbuildingJsonQueryModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v2/get-newbuilding-json-query/',
  requestType: 'json',
  responseType: 'json',
} as TGetNewbuildingJsonQueryModel;

export function createGetNewbuildingJsonQueryModel(
  parameters: IGetNewbuildingJsonQueryRequest,
): TGetNewbuildingJsonQueryModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingJsonQueryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNewbuildingJsonQueryRequest;
}

export async function fetchGetNewbuildingJsonQuery<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingJsonQueryOptions<TResponse200, TResponse400>): Promise<
  TGetNewbuildingJsonQueryResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetNewbuildingJsonQueryModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingJsonQueryResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingJsonQueryResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetNewbuildingJsonQueryResponse;
}
